const doc = [({"da":({"models":({"vote_election_post_contact_result":({"tie":"Uafgjort", "no":"Nej", "yes":"Ja", "no_trust":"Ikke tillid", "trust":"Tillid"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;